const isExplicitFalse = (value) => value === false || value === 'false' || value === 0 || value === '0';

const isAlertVisible = (alert) => !isExplicitFalse(alert?.visible);

const isAlertViewed = (alert) => alert?.viewed === true || alert?.viewed === 'true' || alert?.viewed === 1 || alert?.viewed === '1';

const isAlertCancelled = (alert) => (
    alert?.cancelled === true ||
    alert?.cancelled === 'true' ||
    alert?.cancelled === 1 ||
    alert?.cancelled === '1'
);

export {
    isAlertCancelled,
    isAlertViewed,
    isAlertVisible
};
